import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import Modal from '@components/primitives/Modal/index.client'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faMicrophoneSlash } from '@fortawesome/pro-regular-svg-icons/faMicrophoneSlash'

export const PatientNavigatorSkipModal = ({
  isOpen,
  onSkip,
  setIsOpen,
}: {
  isOpen: boolean
  onSkip: () => void
  setIsOpen: (open: boolean) => void
}) => {
  return (
    <Modal
      bodyClassName='pb-4'
      className='mt-[30%] lg:mt-[10%]'
      onClose={() => setIsOpen(false)}
      size='Large'
      visible={isOpen}
    >
      <div className='flex flex-col gap-8 rounded-lg p-4'>
        <Icon className='text-warning500' icon={faMicrophoneSlash} size='4x' />
        <div className='flex flex-col items-center gap-2 text-center'>
          <Text className='text-neutral800' styleName='p-strong'>
            Are you sure?
          </Text>
          <Text className='text-neutral600'>
            Skipping this step will hurt your chances of enrollment. Speaking
            with a patient navigator helps us better verify your responses.
          </Text>
        </div>
        <div className='flex w-full gap-2'>
          <Button
            className={classMerge(
              buttonClassNames.legacy.outline.white,
              'w-full rounded-full',
            )}
            onClick={onSkip}
          >
            Skip
          </Button>
          <Button
            className={classMerge(
              buttonClassNames.legacy.fill.black,
              'w-full rounded-full border-2 border-neutral100',
            )}
            onClick={() => {
              setIsOpen(false)
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  )
}
